// eslint-disable-next-line
import React, { useEffect, useRef, useState } from "react";
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { connectors } from "../walletConnect/connectors";
import { BsTelegram, BsTwitter } from 'react-icons/bs';
import { FaWallet, FaHandHoldingUsd } from 'react-icons/fa';
import { AiOutlineSwap } from 'react-icons/ai';
import { BiLineChart, BiChevronDown } from 'react-icons/bi';
import { toHex, truncateAddress } from "../walletConnect/utils";
import { useWeb3React } from "@web3-react/core";
import SelectWalletModal from "../walletConnect/modal";
import { getUsdPrice } from "../getUsdPrice";
import { networkParams } from "../walletConnect/networks";


const Menu = () => {
  const {
    library,
    chainId,
    account,
    activate,
    deactivate,
    active
  } = useWeb3React();
  const [isOpen, setIsOpen] = useState(false)
  const onOpen = (e) => {
    setIsOpen(true)
  };
  const onClose = (e) => {
    setIsOpen(false)
  };
  const [signature, setSignature] = useState("");
  const [error, setError] = useState("");
  const [network, setNetwork] = useState(undefined);
  const [message, setMessage] = useState("");
  const [signedMessage, setSignedMessage] = useState("");
  const [verified, setVerified] = useState();

  const handleNetwork = (e) => {
    const id = e.target.value;
    setNetwork(Number(id));
  };

  const handleInput = (e) => {
    const msg = e.target.value;
    setMessage(msg);
  };

  const switchNetwork = async () => {
    try {
      await library.provider.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: toHex(network) }]
      });
    } catch (switchError) {
      if (switchError.code === 4902) {
        try {
          await library.provider.request({
            method: "wallet_addEthereumChain",
            params: [networkParams[toHex(network)]]
          });
        } catch (error) {
          setError(error);
        }
      }
    }
  };

  const signMessage = async () => {
    if (!library) return;
    try {
      const signature = await library.provider.request({
        method: "personal_sign",
        params: [message, account]
      });
      setSignedMessage(message);
      setSignature(signature);
    } catch (error) {
      setError(error);
    }
  };

  const verifyMessage = async () => {
    if (!library) return;
    try {
      const verify = await library.provider.request({
        method: "personal_ecRecover",
        params: [signedMessage, signature]
      });
      setVerified(verify === account.toLowerCase());
    } catch (error) {
      setError(error);
    }
  };

  const refreshState = () => {
    window.localStorage.setItem("provider", undefined);
    setNetwork("");
    setMessage("");
    setSignature("");
    setVerified(undefined);
  };

  const disconnect = () => {
    refreshState();
    deactivate();
  };

  useEffect(() => {
    const provider = window.localStorage.getItem("provider");
    if (provider) activate(connectors[provider]);
  }, []);


  const videoEl = useRef(null);
  const videoEl1 = useRef(null);

  const [loading, setLoading] = useState(true)
  const attemptPlay = () => {
    // SPace
    videoEl1 &&
      videoEl1.current &&
      videoEl1.current.play().catch(error => {
        console.error("Error attempting to play", error);
      });
    // Align
    videoEl &&
      videoEl.current &&
      videoEl.current.play().catch(error => {
        console.error("Error attempting to play", error);
      });
    // window.localStorage.setItem("videoPlayed", "yes")

  };

  useEffect(() => {
    // let videoStatus = window.localStorage.getItem("videoPlayed")
    // if (videoStatus != "yes") {
    attemptPlay();
    // }
  }, []);


  //
  useEffect(() => {
    //const getSesLoader= localStorage.getItem("loader");
    const onPageLoad = () => {
      //  if(getSesLoader!=="false"){
      setTimeout(() => {
        //localStorage.setItem("loader",false)
        setLoading(false)
      }, 3800)
      // };
    }



    if (document.readyState === 'complete') {
      onPageLoad();
    } else {
      window.addEventListener('load', onPageLoad);
      return () => window.removeEventListener('load', onPageLoad);
    }
  }, []);

  const [usdPrice, setUsdPrice] = useState(0);
  useEffect(() => {
    const setusdPrice = async () => {
      let usdPriceHere = await getUsdPrice()
      setUsdPrice(usdPriceHere)
    }
    setusdPrice()
  }, [])

  return (
    <>
      {loading ?
        <>
          <div className="loader video">

            <video playsInline loop muted alt="All the devices" src="./videos/4976871681558578020.webm" ref={videoEl1} />
          </div>
        </> : <></>

      }
      <div className="video">
        <video playsInline loop muted alt="All the devices" src="./videos/4979123481372263336.webm" ref={videoEl} />
      </div>
      {['lg'].map((expand) => (
        <Navbar key={expand} expand={expand} className="">
          <Container>
            <Navbar.Brand href="/"><img src="./images/logo.png" alt="" className="img-responsive" /><span className="logo_price">${parseFloat(usdPrice).toFixed(4)}</span></Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
            >
              <Offcanvas.Header closeButton>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="justify-content-end flex-grow-1 pe-3">
                  <Nav.Link href="./">Home</Nav.Link>
                  <Nav.Link href="/staking">Staking</Nav.Link>
                  <Nav.Link href="/dao">DAO</Nav.Link>
                  <Nav.Link href="https://web.telegram.org/k/#@thegrayscurrency" className="nav_social">
                    <BsTelegram />
                  </Nav.Link>
                  <Nav.Link href="https://mobile.twitter.com/TGCERC20" className="nav_social">
                    <BsTwitter />
                  </Nav.Link>

                  {active ?
                    <Button className="navbtn" onClick={disconnect}>{truncateAddress(account)}</Button>
                    :
                    <Button className="navbtn" onClick={onOpen}>CONNECT WALLET</Button>
                  }
                </Nav>

              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}

      <SelectWalletModal isOpen={isOpen} closeModal={onClose} />
    </>
  );
};

export default Menu;